export default __webpack_public_path__ + "static/Judith-e1585576153990-beb1cdcec426e18f9cedc3f4126050b2.jpg";